import _ from 'lodash';
import {types} from '../utils';

const isAllowedComponentAPI = (type, api) => {
    const apis = types.supportedComponentAPIs[type] || [];
    return _.includes(apis, api);
};

export default isAllowedComponentAPI;
